import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Divider, Grid, Stack, useMediaQuery } from "@mui/material";
import LoaderButton from "./loaderButton";

const ModalWrapper = ({
  src,
  onSuccess,
  openModalBtn,
  modalHeading,
  children,
  open,
  setOpen,
  modalTitle,
  loading,
}) => {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const isMobile = useMediaQuery("(max-width:800px)");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : "30%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 1,
    height: "90vh",
    borderRadius: 2,
  };

  return (
    <div>
      {openModalBtn && (
        <Button size="small" variant="contained" onClick={handleOpen}>
          {openModalBtn}
        </Button>
      )}

      <Modal open={open}>
        <Box sx={style}>
          <div>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mb={1}
            >
              {modalHeading ? (
                <Typography variant="h6">{modalHeading}</Typography>
              ) : (
                <div style={{ width: 100, height: 80 }}>
                  <img
                    style={{ objectFit: "contain" }}
                    src={src}
                    width={"100%"}
                    height={"100%"}
                  />
                </div>
              )}
            </Stack>

            <Typography
              mt={1}
              variant="h5"
              fontWeight={"bold"}
              color={"primary"}
              textAlign={"center"}
            >
              {modalTitle}
            </Typography>
          </div>

          <Grid sx={{ height: "70%", display: "flex" }}>{children}</Grid>
          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            gap={2}
            alignItems={"center"}
            mt={1}
          >
            <Button size="small" variant="outlined" onClick={handleClose}>
              Back
            </Button>
            <LoaderButton
              showLoader={loading}
              disabled={loading}
              buttonText={"Confirm"}
              onClick={onSuccess}
            />
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default ModalWrapper;
